'use strict'
import axios from 'axios'

function getErrorMessage(error) {
  if (error.data && error.data.length > 0) {
    return error.data
  }

  if (error.response) {
    return error.response
  } else if (error.request) {
    return error.request.statusText
  } else if (error.message) {
    return error.message
  } else {
    return error
  }
}

export { axios, getErrorMessage }
